import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Banner from './components/Banner';
import About from './components/About';
import EVChargers from './components/EVChargers';
import CloudManagement from './components/CloudManagement';
import PropertyManagement from './components/PropertyManagement';
import ENotice from './components/ENotice';
import AIMarketing from './components/AIMarketing';
import Services from './components/Services';
import Works from './components/Works';
import WorksPage from './components/WorksPage';
import WorkDetailPage from './components/WorkDetailPage';
import ContactPage from './components/ContactPage';
import Footer from './components/Footer';
import MarqueeSlider from './components/MarqueeSlider';
import './styles.css';
import './App.css';

function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Small delay to allow the page to render before scrolling
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        const headerOffset = 100;
        const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({ top, behavior: 'smooth' });
      } else {
        // Element not yet in DOM — wait briefly and retry
        const timer = setTimeout(() => {
          const elRetry = document.getElementById(id);
          if (elRetry) {
            const headerOffset = 100;
            const top = elRetry.getBoundingClientRect().top + window.scrollY - headerOffset;
            window.scrollTo({ top, behavior: 'smooth' });
          }
        }, 300);
        return () => clearTimeout(timer);
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [pathname, hash]);

  return null;
}

function HomeOrWorkDetail({ language, setLanguage }) {
  const { hash } = useLocation();
  const workMatch = hash.match(/^#work\/(.+)$/);
  if (workMatch) {
    return <WorkDetailPage language={language} setLanguage={setLanguage} workId={workMatch[1]} />;
  }
  if (hash === '#contact') {
    return <ContactPage language={language} setLanguage={setLanguage} />;
  }
  return <HomePage language={language} setLanguage={setLanguage} />;
}

function HomePage({ language, setLanguage }) {
  return (
    <div className="App">
      <Header language={language} setLanguage={setLanguage} />
      <Banner language={language} />
      <About language={language} />
      <Services language={language} />
      <EVChargers language={language} />
      <CloudManagement language={language} />
      <PropertyManagement language={language} />
      <ENotice language={language} />
      <AIMarketing language={language} />
      <Works language={language} />
      {/* <Footer /> */}
    </div>
  );
}

function App() {
  const [language, setLanguage] = useState('en');

  return (
    <BrowserRouter>
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<HomeOrWorkDetail language={language} setLanguage={setLanguage} />} />
        <Route path="/works" element={<WorksPage language={language} setLanguage={setLanguage} />} />
        <Route path="/work/:id" element={<WorkDetailPage language={language} setLanguage={setLanguage} />} />
        <Route path="/contact" element={<ContactPage language={language} setLanguage={setLanguage} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
